import { Country } from "@models/country";
import { Language } from "@models/language";

export enum AccountType {
  Individual = "Individual",
  Organization = "Organization",
}

export enum InstitutionType {
  CareFacility = "Care Facility",
  SupportGroup = "Support Group",
  Helpline = "Helpline",
  CommunityCenter = "Community Center",
  MemoryCareCenter = "Memory Care Center",
  HomeCareService = "Home Care Service",
  HospiceCare = "Hospice Care",
  DayCareCenter = "Day Care Center",
  GeriatricCareManager = "Geriatric Care Manager",
  MentalHealthService = "Mental Health Service",
  VolunteerOrganization = "Volunteer Organization",
  TelehealthService = "Telehealth Service",
  OnlineSupportCommunity = "Online Support Community",
}

export interface Account {
  id: string;
  language: Language;
  type: AccountType;
  country: Country;
  city: string;
  institutionName: string;
  institutionType: InstitutionType;
  numberPatients: number;
  tz: string;
  weeklyReportsEnabled: boolean;
}
